import { useGoogleIdPConnectionQuery } from '#api/google-idp.queries.ts';
import { useSuspenseFeatureFlagsQuery } from '#api/org.queries.ts';

/**
 * {@link useGoogleDirectorySyncAvailable} is whether a user sync can run: the feature is on, a Google Workspace is
 * connected, and it isn't paused. The connection is not loaded with suspense, so a Google outage or a slow read
 * never holds up the page it sits on; until it loads, sync is simply not offered.
 */
export function useGoogleDirectorySyncAvailable() {
  const { data: { GOOGLE_IDP_SYNC } = {} } = useSuspenseFeatureFlagsQuery();
  const { data } = useGoogleIdPConnectionQuery({ enabled: Boolean(GOOGLE_IDP_SYNC) });
  const connection = data?.data;

  return Boolean(GOOGLE_IDP_SYNC && connection && !connection.paused);
}
